module.exports = "<div [innerHTML]=\"info\"></div>\n"